const yup = require("yup");

const createSitting = yup.object({
  examinationtype: yup.string().min(1, "Examination type is a required field").required("Examination type is a required field"),
  examinationcenter: yup.string().min(1, "Examination center number is a required field").required("Examination center number is a required field"),
  examinationyear: yup
    .string()
    .min(4, "Year of examination cannot be less than 4 character")
    .max(4, "Year of examination cannot be above 4 characters")
    .required("Year of examination is a required field"),
  examinationnumber: yup.string().required("Examination number is a required field"),
});
module.exports = {
  createSitting,
};
